import {
  ApplicationConfig,
  ErrorHandler,
  importProvidersFrom,
  provideZoneChangeDetection,
  provideAppInitializer,
  inject,
  PLATFORM_ID,
} from '@angular/core';
import { FaroErrorHandler } from '@core/faro/faro-error.handler';
import { provideRouter, withViewTransitions } from '@angular/router';
import { provideNgxSkeletonLoader } from 'ngx-skeleton-loader';
import { routes } from './app.routes';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { httpRequestInterceptor } from '@core/interceptors/http-request.interceptor';
import { httpResponseInterceptor } from '@core/interceptors/http-response.interceptor';
import { BrowserModule } from '@angular/platform-browser';
import { NgbModalModule } from '@ng-bootstrap/ng-bootstrap';
import { provideQuillConfig } from 'ngx-quill';
import { EventService } from '@base/services/private/event.service';
import { isPlatformBrowser } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MODAL_SERVICE } from '@base/services/private/modal-service.token';
import { ModalService } from '@base/services/private/modal.service';

export const appConfig: ApplicationConfig = {
  providers: [
    { provide: ErrorHandler, useClass: FaroErrorHandler },
    { provide: MODAL_SERVICE, useExisting: ModalService },
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes, withViewTransitions()),
    provideHttpClient(withInterceptors([httpRequestInterceptor, httpResponseInterceptor]), withFetch()),
    provideNgxSkeletonLoader({
      theme: {
        extendsFromRoot: true,
        height: '30px',
        backgroundColor: sessionStorage.getItem('isBgDarkMode') === 'true' ? 'var(--dark)' : '',
      },
    }),
    importProvidersFrom(BrowserModule, NgbModalModule, BrowserAnimationsModule),
    provideQuillConfig({
      modules: {
        toolbar: [
          ['bold', 'italic', 'underline', 'strike'],
          [{ list: 'ordered' }, { list: 'bullet' }],
        ],
      },
      theme: 'snow',
    }),
    provideAppInitializer(() => {
      const platformId = inject(PLATFORM_ID);
      const eventService = inject(EventService);

      if (isPlatformBrowser(platformId)) {
        // Only run in the browser during app initialization
        // This is to ensure that the event directory is loaded before the app starts
        // We need the state to check is it branded or unbranded (for guards)
        return eventService.loadInitEventDir();
      }

      console.info('Running on server');
      return Promise.resolve();
    }),
  ],
};
